import React from 'react';

export function ProjectCard({ card }) {
  return (
    <div className="relative flex h-full flex-col overflow-hidden rounded-lg border border-[#00f3ff]/20 bg-[linear-gradient(180deg,rgba(24,43,75,0.82),rgba(14,27,49,0.88))] shadow-[0_12px_36px_rgba(0,0,0,0.18)] backdrop-blur-[14px]">
      <div
        className="w-full bg-[#152744]/45 bg-cover bg-center pt-[56.25%] bg-blend-screen"
        style={{ backgroundImage: `url(${card.imageUrl})` }}
        title={card.title}
        role="img"
        aria-label={card.title}
      />
      <div className="flex-grow p-4 font-mono">
        <h2 className="mb-2 font-mono text-2xl font-bold leading-[1.25] text-white">
          {card.title}
        </h2>
        <p className="mb-1.5 text-base leading-[1.55] text-slate-200">
          {card.desc}
        </p>
        {card.detail && (
          <p className="mb-1.5 text-sm leading-[1.62] text-slate-300">
            {card.detail}
          </p>
        )}
        <p className="mt-4 font-mono text-[0.85em] font-bold text-[#00f3ff]">
          {card.tags.join(', ')}
        </p>
      </div>
      <div className="flex justify-between p-2">
        {card.url && (
          <a
            href={card.url}
            target="_blank"
            className="no-underline"
            rel="noreferrer"
          >
            <span className="inline-flex items-center justify-center rounded-[2px] px-2.5 py-1 font-mono text-[0.8125rem] font-medium uppercase tracking-[0.06em] text-[#00f3ff] transition-all duration-300 hover:bg-[#00f3ff]/10">
              View
            </span>
          </a>
        )}
        <span className="inline-flex px-2.5 py-1 font-mono text-sm font-medium uppercase text-slate-400">
          {card.year}
        </span>
      </div>
    </div>
  );
}
